import * as React from "react";
import { TVChartContainer } from "./components/TVChartContainer/index";

function getSymbolFromUrl() {
  const regex = new RegExp("[\\?&]token=([^&#]*)");
  const results = regex.exec(window.location.search);
  return results === null
    ? undefined
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}
class App extends React.Component {
  render() {
    return <TVChartContainer symbol={getSymbolFromUrl()} />;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx